import TradeInformation from "@/components/misc/TradeInformation"
import SimpleTable from "@/components/table/SimpleTable"
import { useTrades, useUserTypes } from "@/data/coreDataStore"
import type { UserMetadata } from "@/models"
import { defineComponent, requiredProp, type ReactiveComponent } from "vue-utils"

interface Props {
	users: UserMetadata[]
}

const OnSiteNowTable: ReactiveComponent<Props> = (props) => {
	const trades = useTrades()
	const userTypes = useUserTypes()

	function renderRow(user: UserMetadata) {
		const trade = user.tradeId === null ? null : (trades.get(user.tradeId) ?? null)

		return (
			<tr key={user.id}>
				<td>
					<TradeInformation trade={trade}>{trade?.name ?? "-"}</TradeInformation>
				</td>
				<td>{user.lastName}</td>
				<td>{user.firstName}</td>
				<td>{userTypes.get(user.userTypeId)?.name}</td>
			</tr>
		)
	}

	return () =>
		props.users.length === 0 ? (
			<p>All staff in the system are currently clocked in</p>
		) : (
			<SimpleTable style={{ tableLayout: "auto" }}>
				<thead>
					<tr>
						<th>Trade</th>
						<th>Surname</th>
						<th>Forename</th>
						<th>User Type</th>
					</tr>
				</thead>
				<tbody>{props.users.map(renderRow)}</tbody>
			</SimpleTable>
		)
}

export default defineComponent(OnSiteNowTable, {
	users: requiredProp(Array),
})
